import { getReceipt, getNutritionSummary } from 'actions/baskets';
import { mapV3BasketStateToReceiptParams } from 'helpers/requestTransformers';
import {
  SET_EDITED_BASKET_V3,
  UNDO_BASKET_EDITS_V3,
  CLEAR_EDITED_BASKET_V3,
  SET_BASKET_SERVINGS_V3,
  UPDATE_MEAL_SERVINGS_V3,
  ADD_PAIRED_MEALS_V3,
  REMOVE_PAIRED_MEAL_V3,
  ADD_MEAL_V3,
  REMOVE_MEAL_V3,
  CHANGE_MEAL_OPTION_V3,
  UNDO_MEAL_OPTIONS_V3,
  ADD_SERVINGS_V3,
  REMOVE_SERVINGS_V3,
  SET_CLEAN_BASKET_EDIT_STATE_V3,
  HAS_BASKET_STATE_CHANGED_V3,
  SET_HAS_PENDING_EDITS_V3,
  CLEAR_PENDING_EDITS_V3,
} from 'lib/constants/v3Actions';
import * as fromV3Dashboard from 'reducers/v3/dashboard';

export const updateBasketReceipt = (
  menuSlug,
  includeDiscounts = false,
  excludeMealPrices = false
) => {
  return async (dispatch, getState) => {
    const state = getState();
    const basket = fromV3Dashboard.selectBasket(state, menuSlug);
    const mealServings = fromV3Dashboard.selectMealServingsForBasketEdits(state);
    const selectedMealOptions = fromV3Dashboard.selectMealOptionsForBasketEdits(state);
    const selectedPairings = fromV3Dashboard.selectPairingsForBasketEdits(state);
    const receiptParams = mapV3BasketStateToReceiptParams(
      basket,
      {
        mealServings,
        selectedMealOptions,
        selectedPairings,
      },
      includeDiscounts,
      excludeMealPrices
    );

    return await dispatch(getReceipt(receiptParams));
  };
};

export const updateNutritionSummary = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const mealServings = fromV3Dashboard.selectMealServingsForBasketEdits(state);

    return await dispatch(getNutritionSummary({ mealServings }));
  };
};

export const setEditedBasket = ({ basket, selectedPairings }) => ({
  type: SET_EDITED_BASKET_V3,
  basket,
  selectedPairings,
});

export const undoBasketEdits = ({ basket, selectedPairings }) => ({
  type: UNDO_BASKET_EDITS_V3,
  basket,
  selectedPairings,
});

export const clearEditedBasket = () => ({
  type: CLEAR_EDITED_BASKET_V3,
});

export const setBasketServings = mealServings => ({
  type: SET_BASKET_SERVINGS_V3,
  mealServings,
});

export const updateMealServings = ({ mealId, menuSlug, mealServings }) => ({
  type: UPDATE_MEAL_SERVINGS_V3,
  mealServings,
  menuSlug,
  mealId,
});

export const addMeal = ({ mealId, startServings, menuSlug, editStage }) => ({
  type: ADD_MEAL_V3,
  menuSlug,
  mealId,
  startServings,
  editStage,
});

export const removeMeal = ({ mealId, menuSlug, editStage }) => ({
  type: REMOVE_MEAL_V3,
  menuSlug,
  mealId,
  editStage,
});

export const addServings = ({ mealId, menuSlug, mealServings }) => ({
  type: ADD_SERVINGS_V3,
  menuSlug,
  mealId,
  mealServings,
});

export const addPairedMeals = ({ menuSlug, hostMealId, pairedMealId }) => ({
  type: ADD_PAIRED_MEALS_V3,
  menuSlug,
  hostMealId,
  pairedMealId,
});

export const removePairedMeal = ({ menuSlug, hostMealId }) => ({
  type: REMOVE_PAIRED_MEAL_V3,
  menuSlug,
  hostMealId,
});

export const removeServings = ({ mealId, menuSlug, mealServings }) => ({
  type: REMOVE_SERVINGS_V3,
  menuSlug,
  mealId,
  mealServings,
});

export const changeMealOption = ({ mealId, mealOptionGroupId, mealOption }) => ({
  type: CHANGE_MEAL_OPTION_V3,
  mealId,
  mealOptionGroupId,
  mealOption,
});

export const undoMealOptions = (mealId, mealOptions) => ({
  type: UNDO_MEAL_OPTIONS_V3,
  mealId,
  mealOptions,
});

export const setCleanBasketEditState = (mealServings, mealOptions) => ({
  type: SET_CLEAN_BASKET_EDIT_STATE_V3,
  mealServings,
  mealOptions,
});

export const hasBasketStateChanged = (mealServings, mealOptions) => ({
  type: HAS_BASKET_STATE_CHANGED_V3,
  mealServings,
  mealOptions,
});

export const setPendingBasketEdits = () => ({
  type: SET_HAS_PENDING_EDITS_V3,
});

export const clearPendingBasketEdits = () => ({
  type: CLEAR_PENDING_EDITS_V3,
});
